import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { FeatureFlagsService } from '../core/feature-flags.service';

export class NoFeatureFlagForGuard extends Error {
  message = 'No feature flags was set for the FeatureFlagGuard';
  name = 'NO_FEATURE_FLAG_FOR_GUARD';
}
const REDIRECT_URL = '/';

@Injectable()
export class FeatureFlagsGuard implements CanActivate {
  constructor(private featureFlagsService: FeatureFlagsService , private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    if (!route.data.featureFlags || route.data.featureFlags.length === 0) {
      console.error(new NoFeatureFlagForGuard());

      return of(this.router.parseUrl(REDIRECT_URL));
    }

    return this.featureFlagsService.hasFlags(route.data.featureFlags)
                                   .pipe(
                                     map(active =>
                                        active ? true : this.router.parseUrl(REDIRECT_URL))
                                   );
  }
}
